import { useEffect, useRef } from "react";

// ★ 2026-10-29 하단 탭 다시 누르기 — 이미 보고 있는 탭을 한 번 더 누르면 그 화면의 첫 줄 칩이 다음 칩으로 넘어간다
//  (마지막 칩 다음은 처음으로). 하단 탭(Footer)이 이벤트를 쏘고, 칩이 있는 탭 화면이 이 훅으로 받는다.
//  받는 화면이 없으면(홈·MY) Footer 가 맨 위로 올린다.
export const TAB_RESELECT_EVENT = "muyeon:tab-reselect";

/** 하단 탭에서 쏜다. 받은 화면이 있으면 true. */
export function emitTabReselect(path) {
  const detail = { path, handled: false };
  window.dispatchEvent(new CustomEvent(TAB_RESELECT_EVENT, { detail }));
  return detail.handled;
}

/** 칩 목록에서 지금 값의 다음 값(끝이면 처음). 지금 값이 목록에 없으면 두 번째(처음 칩은 이미 보고 있다고 본다). */
export function nextChipValue(options, value) {
  const values = (options || []).map((o) => (typeof o === "object" ? o.value : o));
  if (values.length < 2) return values[0];
  const i = values.indexOf(value);
  return values[(i < 0 ? 1 : i + 1) % values.length];
}

/** 탭 화면에서 쓴다 — path 탭을 다시 누르면 onReselect() 호출. scrollTop:false 면 맨 위로 올리지 않는다(칩이 섹션 이동인 화면). */
export default function useTabReselect(path, onReselect, { scrollTop = true } = {}) {
  const ref = useRef(onReselect);
  ref.current = onReselect;
  useEffect(() => {
    const on = (e) => {
      if (e.detail?.path !== path || !ref.current) return;
      e.detail.handled = true;
      ref.current();
      // 고른 칩이 가로 스크롤 밖에 있으면 보이게, 화면은 맨 위로.
      window.requestAnimationFrame(() => {
        if (scrollTop) window.scrollTo({ top: 0, behavior: "smooth" });
        document.querySelectorAll(".tab-btn.selected").forEach((el) => {
          el.scrollIntoView?.({ behavior: "smooth", block: "nearest", inline: "center" });
        });
      });
    };
    window.addEventListener(TAB_RESELECT_EVENT, on);
    return () => window.removeEventListener(TAB_RESELECT_EVENT, on);
  }, [path, scrollTop]);
}
